import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { CommunicationService } from '../../communication/communication.service';
import { take, takeUntil } from 'rxjs/operators';
import { ResultSetConfig, ResultSetIds } from '../../models/results/result-set-config.model';
import { ConfiguredToastrService } from '../../helper/toastr/configured-toastr.service';
import { AnessaTranslationService } from '../../helper/translation/anessa-translation.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ResultSetConfigService implements OnDestroy {
  private onDestroyNotifier = new EventEmitter();

  constructor(
    private commService: CommunicationService,
    private toastrService: ConfiguredToastrService,
    private translationService: AnessaTranslationService
  ) {

  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  fetch(resultSetIds: string | string[], projectID: string) {
    return this.commService.postRequest({ resultSetIds: resultSetIds, projectID: projectID },
      '/wsasapi/resultsetconfig/fetchResultConfig') as Observable<ResultSetIds>;
  }

 save(config: ResultSetConfig, projectID: string) {
    // map isn't able to be JSON.stringify-ed so this is needed, and a re-map is need in the backend
    (this.commService.postRequest({ resultSetConfig: config.getJsonStringify(), projectID: projectID },
      'wsasapi/resultsetconfig/saveResultConfig') as Observable<{ success: boolean}>)
      .pipe(take(1))
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe((res) => {
        if (res && res.success) {
          this.toastrService.success(this.translationService.get('RESULTS.RESULT_CONFIG.DEFAULTS_SAVED'));
        }
      });
  }
}
